import { Link } from "react-router-dom";

const EmpSuccess = ({ all_routes }) => {
  return (
    <div className="modal fade" role="dialog">
      <div className="modal-dialog modal-dialog-centered modal-sm">
        <div className="modal-content">
          <div className="modal-body">
            <div className="text-center p-3">
              <span className="avatar avatar-lg avatar-rounded bg-success mb-3">
                <i className="ti ti-check fs-24" />
              </span>
              <h5 className="mb-2">Employee Added Successfully</h5>
              <p className="mb-3">
                Stephan Peralt has been added with Client ID :{" "}
                <span className="text-primary">#EMP - 0001</span>
              </p>
              <div>
                <div className="row g-2">
                  <div className="col-6">
                    <Link
                      to={all_routes.employeeList}
                      className="btn btn-dark w-100"
                    >
                      Back to List
                    </Link>
                  </div>
                  <div className="col-6">
                    <Link
                      to={all_routes.employeedetails}
                      className="btn btn-primary w-100"
                    >
                      Detail Page
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmpSuccess;
